export enum WorkspaceItemStatus {
  ADDED = 'added',
  EDITED = 'edited',
  DELETED = 'deleted',
}
